import { jsx, Fragment } from 'react/jsx-runtime';
import { LinkButton, Button } from '@clover-web-lib-sprout/button';
import { forwardRef } from 'react';

/**
 * @title
 *  Action Button
 * @label
 *  Action Button
 * @shortdescription
 *  Clover styled Action Button.
 * @keywords
 *  [Button,Action,Action Button, html button, anchor]
 * @description
 * Clover styled Action Button. Note: Use sentence case for the label!
 * @componentUsage
 * <Action variant="secondary">
    Secondary click
   </Action>
 * @example
   <ActionSproutExample />
 */
const Action = forwardRef(({ href, to, variant = 'primary', leadingIcon, trailingIcon, ...passThroughProps }, ref) => {
    const includeIcons = variant !== 'upsell';
    return (jsx(Fragment, { children: to ? (jsx(LinkButton, { ref: ref, variant: variant, ...(includeIcons ? (leadingIcon ? { leadingIcon } : trailingIcon ? { trailingIcon } : {}) : {}), ...passThroughProps, to: to })) : href ? (jsx(LinkButton, { ref: ref, variant: variant, ...(includeIcons ? (leadingIcon ? { leadingIcon } : trailingIcon ? { trailingIcon } : {}) : {}), ...passThroughProps, href: href })) : (jsx(Button, { ref: ref, variant: variant, ...(includeIcons ? (leadingIcon ? { leadingIcon } : trailingIcon ? { trailingIcon } : {}) : {}), ...passThroughProps })) }));
});
Action.displayName = 'Action';

export { Action };
//# sourceMappingURL=index.mjs.map
